import { Storage } from '@capacitor/storage';

export default ({
    namespaced: true,
    state: {
        loggedIn: false,
        checkedStorage: false,
        token: '',
        superuser: false
    },
    mutations: {
        // Postavi status prijave i token.
        SET_TOKEN(state, token) {
            state.loggedIn = true;
            state.token = token;
        },
        // Spremi token u web preglednik ili uređaj (ovisno o platformi).
        SAVE_TOKEN(_state, token) {
            Storage.set({ key: 'token', value: token });
        },
        // Izbriši token.
        REMOVE_TOKEN(state) {
            state.loggedIn = false;
            state.token = '';
            Storage.remove({ key: 'token' });
        },
        UPDATE_CHECKED_STORAGE(state, value) {
            state.checkedStorage = value;
        },
        SET_SUPERUSER(state, value) {
            state.superuser = value;
            Storage.set({ key: 'superuser', value: value });
        }
    },
    getters: {
        isLoggedIn: state => state.loggedIn,
        token: state => state.token,
        isSuperuser: state => state.superuser
    },
    actions: {
        // Prijavi se, postavi i spremi token.
        async login({ commit }, { token, superuser }) {
            commit('SET_TOKEN', token);
            commit('SAVE_TOKEN', token);
            commit('SET_SUPERUSER', superuser);
        },
        // Provjeri (samo jedanput) postoji li token te prijavi korisnika ako postoji.
        async loginFromStorage({ state, commit }) {
            if(state.checkedStorage) return;
            
            commit('UPDATE_CHECKED_STORAGE', true);

            if(state.loggedIn) return;

            const { value } = await Storage.get({ key: 'token' });
            const { value: superuser } = await Storage.get({ key: 'superuser' });

            if(value) {
                commit('SET_TOKEN', value);

                if(superuser) {
                    commit('SET_SUPERUSER', superuser);
                }
            }
        },
        // Odjavi se, ukloni token.
        async logout({ commit }) {
            commit('REMOVE_TOKEN');
            commit('SET_SUPERUSER', false);
        }
    }
});